
<!--
  Navigation bar
-->

<template lang="html">
  <div class="overlay">

      <div class="popup-container container-fluid desktop">
        <div class="popup-close" @click="closePopup" v-bind:class="{ 'active': true }">
            <div class="burger-bar close-bar-2"></div>
            <div class="burger-bar close-bar-1"></div>
          </div>
        <div class="row  popup-copy-container ">

          <div class="col-md-6 text-center">
              <img class="popup-logo-image" :src="'static/img/content'+popup.popup_image_logo" />

              <img class="popup-title-image" :src="'static/img/content'+popup.popup_image_title" />
              <p v-for="(p, index) in popup.body" class="page-paragraph" v-html="p"></p>

              <div @click="clickLink" class="router-link-container" :to="popup.popup_link"><link-button :label="popup.popup_button" ></link-button></div>
          </div>

          <div class="col-md-6 text-center">
              <img :src="'static/img/content'+popup.popup_image_main_desktop" />
              <!-- <div class="popup-main-image" :style=" { 'background-image': 'url(static/img/content'+popup.popup_image_main +')' } "></div> -->
          </div>

        </div>
      </div>

      <div class="popup-container container mobile">
        <div class="popup-close" @click="closePopup" v-bind:class="{ 'active': true }">
            <div class="burger-bar close-bar-2"></div>
            <div class="burger-bar close-bar-1"></div>
          </div>
        <div class="row ">

          <div class="col-md-12 text-center">
              <img class="popup-logo-image" :src="'static/img/content'+popup.popup_image_logo" />

              <img class="popup-title-image" :src="'static/img/content'+popup.popup_image_title" />
              <p v-for="(p, index) in popup.body" class="page-paragraph" v-html="p"></p>

              <div @click="clickLink" class="router-link-container" :to="popup.popup_link"><link-button @click="closePopup" :label="popup.popup_button" ></link-button></div>
          </div>

          <div class="col-md-12 text-center popup-main-image-mobile">
              <img :src="'static/img/content'+popup.popup_image_main_mobile" />
              <!-- <div class="popup-main-image" :style=" { 'background-image': 'url(static/img/content'+popup.popup_image_main +')' } "></div> -->
          </div>

        </div>
      </div>
  
  </div>
</template>

<style>

.overlay {
  position: fixed;
  width:100%;
  height:100%;
  background-color: rgba(0,0,0,0.8);
  top:0;
  z-index: 9999;
}
.popup-container {
  position: absolute;
  left:50%;
  top:50%;
  width: 90%!important;
  max-width: 375px;
  background-color: #fff;
  height: auto;
  transform: translate3d(-50%, -50%, 0);
  -webkit-transform: translate3d(-50%, -50%, 0);
  box-sizing: border-box;
  padding: 30px;
}
.popup-copy-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-title-image {
  margin-bottom: 45px;
}
.popup-logo-image {
  max-width: 200px;
  margin-bottom: 45px;
}
.popup-main-image {
  position: absolute;
  width:100%;
  height: 100%;
}
.popup-main-image-mobile {
  margin-top: 45px;
}

.popup-close {
  position: absolute;
  top:0;
  right:0;
  width: 30px;
  height: 30px;
  cursor: pointer;

}
.popup-close:active {
  background-color: #d1a699;
}
.popup-close:active > .burger-bar {
  background-color: #fff;
}

.close-bar-1 {
  -webkit-transform: translate3d(0px, 14px, 0) rotate(-135deg);
  -webkit-transition: 0.3s ease-in-out;
  transform: translate3d(0px, 14px, 0) rotate(-135deg);
  transition: 0.3s ease-in-out;
}
.close-bar-2 {
  -webkit-transform: translate3d(0px, 14px, 0) rotate(135deg);
  -webkit-transition: 0.3s ease-in-out;
  transform: translate3d(0px, 14px, 0) rotate(135deg);
  transition: 0.3s ease-in-out;
}

@media (min-width: 576px) {
  .popup-container {
    max-width: 375px;
  }
}
@media (min-width: 768px) {
  .popup-container {
    max-width: 600px;
    max-height: 500px;
  }
}
@media (min-width: 992px) {
  .popup-container {
    max-width: 700px;
    max-height: 500px;
  }
}
@media (min-width: 1200px) {

}

.popup-container .page-paragraph {
  font-size: 11px;
}


</style>

<script>
import {commontools} from '../mixins/Styling'
import {popup} from '../../content.json'
import LinkButton from '../components/LinkButton'

export default {
  name: 'popup',
  mixins: [commontools],
  data () {
    return {
      popup
    }
  },
  methods: {
    closePopup () {
      this.popup.showMe = false
    },
    clickLink () {
      this.popup.showMe = false
      this.$router.push(popup.popup_route)
    }
  },
  mounted: function () {

  },
  updated: function () {
  },
  components: {
    LinkButton
  }
}

</script>



// WEBPACK FOOTER //
// PopupOverlay.vue?35d43384